var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"d-flex flex-column align-center no-print",attrs:{"absolute":""}},[_c('env-chip'),_c('div',{staticClass:"text-center body-2"},[_vm._v(" © Copyright "+_vm._s(_vm.year)+" - "+_vm._s(_vm.$t("copyright"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }